import { Component, OnInit } from '@angular/core';
import { Paginacao } from '../../comum/modelos/paginacao';
import { Evento } from '../../comum/eventos/evento';
import { ComumService } from '../../comum/comum.service';
import { ProcessoCliente } from '../../comum/modelos/processo-cliente';
import { ProcessoService } from '../processo.service';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { ConfirmationService } from 'primeng/primeng';
import { CookieService } from 'angular2-cookie/core';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-listar-processos',
  templateUrl: './listar-processos.component.html',
  styleUrls: ['./listar-processos.component.css']
})
export class ListarProcessosComponent implements OnInit {

  filtroPesquisaNomeProcesso: string;
  processosCliente: ProcessoCliente[];
  paginacao: Paginacao;
  evento: Evento;

  selecionados: boolean;
  statusCode: number;

  public loading = false;

  constructor(private _processoService: ProcessoService,
    private _comumService: ComumService,
    private confirmationService: ConfirmationService,
    private router: Router,
    private _cookieService: CookieService,
    private _authService: AuthService) {
    this.paginacao = new Paginacao();
    this.processosCliente = new Array<ProcessoCliente>();
    this.evento = this._comumService.evento;

    if (this.evento !== undefined) {
      setTimeout(() => {
        this._comumService.cleanEvent();
      }, 3000);
    }
  }

  ngOnInit() {
    this.paginacao.itens = 5;
    this.paginacao.page = 1;
    this.loading = true;

    const self = this;
    const idCliente = parseInt(this._cookieService.get('idCliente'));
    const pc = this._processoService.obterProcessosClienteHttp(idCliente);
    const p = this._processoService.obterProcessosHttp();

    forkJoin(p, pc)
      .subscribe(([processos, processosCliente]) => {
        for (const processo of processos) {
          const novoProcessoCliente = new ProcessoCliente();
          novoProcessoCliente.processo = processo;
          novoProcessoCliente.idCliente = idCliente;
          for (const processoCliente of processosCliente) {
            novoProcessoCliente.setoresVinculados = 0;
            if (processoCliente.processo.idProcesso === processo.idProcesso) {
              novoProcessoCliente.setoresVinculados = processoCliente.setoresVinculados;
              novoProcessoCliente.idProcessoCliente = processoCliente.idProcessoCliente;
              novoProcessoCliente.selecionado = true;
              break;
            }
          }
          self.processosCliente.push(novoProcessoCliente);
        }
        self.loading = false;
      });
  }

  removerProcesso(processoCliente: ProcessoCliente): void {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja excluir o processo?',
      accept: () => {
        this.loading = true;
        this._processoService.removerProcessoHttp(processoCliente.processo.idProcesso).subscribe(response => {
          this.loading = false;
          this.statusCode = response.status;
          this._comumService.evento.deletar = true;
          this.removerProcessoFromList(this.processosCliente, processoCliente);
          setTimeout(() => {
            this.evento.limparEventos();
          }, 3000);
        }, errorCode => {
          this.statusCode = errorCode;
          this._comumService.evento.deletar = true;
          this._comumService.evento.error = true;
          this.loading = false;
          setTimeout(() => {
            this.evento.limparEventos();
          }, 3000);
        });
      },
      reject: () => {
      }
    });
  }


  removerProcessoFromList(processosCliente: ProcessoCliente[], processoCliente: ProcessoCliente): void {
    const index = this.obterIdProcessoCliente(processosCliente, processoCliente);
    processosCliente.splice(index, 1);
  }

  obterIdProcessoCliente(processosCliente: ProcessoCliente[], processoCliente: ProcessoCliente): number {
    return processosCliente.indexOf(processoCliente);
  }

  pesquisarPorFiltro(filtro: any): void {
    this.filtroPesquisaNomeProcesso = filtro.value;
  }

  selecionar(processoCliente: ProcessoCliente, event): void {
    if (processoCliente.selecionado && processoCliente.idProcessoCliente !== null
      && processoCliente.idProcessoCliente !== undefined && processoCliente.setoresVinculados > 0) {
      this.confirmationService.confirm({
        message: 'Precisa desvincular o Setor',
        rejectVisible: false,
        accept: () => {
          event.target.checked = true;
        },
        reject: () => {
          event.target.checked = true;
        }
      });
    } else {
      processoCliente.selecionado = !processoCliente.selecionado;
      processoCliente.alterado = true;
    }
  }

  selecionarTodos(): void {
    this.selecionados = !this.selecionados;
    if (!this.selecionados) {
      for (let i = 0; i < this.processosCliente.length; i++) {
        if (this.processosCliente[i].setoresVinculados > 0) {
          this.confirmationService.confirm({
            message: 'Precisa desvincular o Setor',
            rejectVisible: false,
            accept: () => {
            },
            reject: () => {
            }
          });
          break;
        }
      }
    } else {
      this.processosCliente.forEach(processoCliente => {
        processoCliente.selecionado = this.selecionados;
        processoCliente.alterado = true;
      });
    }
  }

  onSubmit(): void {
    this.loading = true;
    const processosClienteInsert = new Array<ProcessoCliente>();
    const processosClienteRemove = new Array<ProcessoCliente>();
    this.processosCliente.forEach(processoCliente => {
      if (!processoCliente.selecionado && processoCliente.idProcessoCliente !== undefined && processoCliente.alterado) {
        processosClienteRemove.push(processoCliente);
      } else if (processoCliente.selecionado && processoCliente.idProcessoCliente === undefined
        && processoCliente.alterado) {
        processosClienteInsert.push(processoCliente);
      }
    });
    if (processosClienteRemove.length > 0) {
      this._processoService.removerProcessosClienteHttp(processosClienteRemove)
        .subscribe(response => {
          this.loading = false;
          this.statusCode = response.status;
          this._comumService.evento.cadastro = true;
          this.router.navigate(['listar-processos']);
        }, errorCode => {
          this.statusCode = errorCode;
          this.loading = false;
        });
    }
    if (processosClienteInsert.length > 0) {
      this._processoService.cadastrarProcessosClienteHttp(processosClienteInsert)
        .subscribe(response => {
          this.loading = false;
          this.statusCode = response.status;
          this._comumService.evento.cadastro = true;
          this.router.navigate(['listar-processos']);
        }, errorCode => {
          this.statusCode = errorCode;
          this.loading = false;
        });
    }
    this.loading = false;
  }
}




// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/processo/listar-processos/listar-processos.component.ts